import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import TelemonialLogo from "../components/logo-svg.vue";

Vue.use(Vuetify);

const ACCENT_COLOR = "#05676D";
const ACCENT_COLOR_LIGHTER = "#07969f";

export default new Vuetify({
  treeShake: true,
  defaultAssets: {
    font: {
      family: "Libre Baskerville",
    },
  },
  breakpoint: {
    mobileBreakpoint: "xs",
  },
  icons: {
    values: {
      logo: {
        component: TelemonialLogo,
      },
    },
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: {
          base: ACCENT_COLOR,
          lighten1: ACCENT_COLOR_LIGHTER,
        },
        secondary: "#242428",
        anchor: ACCENT_COLOR, // Changes the default link color
        background: "#ECECEC",
        card: "FFFFFF", // TODO: Change rename to surface
        primaryText: ACCENT_COLOR,
        text: {
          base: "#000000",
          lighten1: "#555555",
          lighten2: "#737373",
        },
        icon: "A6A6A6",
        disabled: "#4d4d4d",
        divider: "#c2c2c2",
        ok: "#4caf50",
        warning: "E8CA31",
        danger: "#ff0000",
      },
      dark: {
        primary: {
          base: ACCENT_COLOR,
          lighten1: ACCENT_COLOR_LIGHTER,
        },
        secondary: "#ffffff",
        anchor: ACCENT_COLOR_LIGHTER,
        background: "#242428",
        card: "#3c3c43",
        primaryText: ACCENT_COLOR_LIGHTER,
        text: {
          base: "#ffffff",
          lighten1: "#d8d8d9",
          lighten2: "#bbbbbd",
        },
        icon: "bbbbbd",
        disabled: "#7D7D82",
        divider: "#3c3c43",
        ok: "#4caf50",
        warning: "E8CA31",
        danger: "#ff0000",
      },
    },
  },
});
